export const REVIEWS_HELPFUL_YES_CLICKED = 'reviews.helpful.yes.clicked';
export const REVIEWS_HELPFUL_NO_CLICKED = 'reviews.helpful.no.clicked';
export const REVIEWS_FLAG_REVIEW_CLICKED = 'reviews.flag.review.clicked';
export const REVIEWS_SORT_BY_CHANGED = 'reviews.sort.by.changed';

export interface IReviewsPayload {
    productId: string;
    displayName: string;
    selectedValue?: string;
}

export type ServiceRatingsReviewsEvents = {
    [REVIEWS_HELPFUL_YES_CLICKED]: IReviewsPayload;
    [REVIEWS_HELPFUL_NO_CLICKED]: IReviewsPayload;
    [REVIEWS_FLAG_REVIEW_CLICKED]: IReviewsPayload;
    [REVIEWS_SORT_BY_CHANGED]: IReviewsPayload;
};
